/**
 * Der Stand reist im Header `X-Stand` (AP-36 8.1, S-4), nicht im Body — die
 * Validierung im Backend lehnt unbekannte Body-Felder ab.
 *
 * ```ts
 * schreibe: (patch, stand) => api.patch(`/projects/${id}`, patch, mitStand(stand)).then((r) => r.data)
 * ```
 */
export function mitStand(stand: string | undefined): { headers: Record<string, string> } {
  return { headers: stand ? { 'X-Stand': stand } : {} }
}
